import React, {useEffect, useState} from 'react';
import useStore from "../Store";
import ConstructionSiteApi from "../API/constructionSiteApi";
import GoAroundApi from "../API/goAroundApi";
import {MainDiv, LineDiv, Text, SectionDiv, SelectorsDiv, SelectorDiv, ButtonsDiv, Button} from "./design.js"
import ConstructionSiteProgress from "./ConstructionSite/ConstructionSiteProgress";
import ConstructionSiteDayWorks from "./ConstructionSiteDayWorks";
import ToDo from "./ToDo";
import PhotoProgressWorks from "./PhotoProgressWorks";


const GoAroundMain = () => {
    const Houses=useStore((state)=>state.Houses.Location1);
    const Floors=useStore((state)=>state.Floors);
    const [selectedGoal, setSelectedGoal]=useState(null);
    const [Data, setData]=useState({status:"local"});
    const [selectedHouse, setSelectedHouse]=useState(null)
    const [selectedFloor, setSelectedFloor]=useState(null)



    useEffect( ()  => {
        const LocalData=JSON.parse(localStorage.getItem("Data"));
        // console.log (LocalData)
        if(LocalData){
            if(LocalData.status === "local")
            if(window.confirm("There is local saved data. Want you to use this data?"))
                setData({...LocalData})
        }
    }, []);

    async function saveData(){
        GoAroundApi.addGoAroundData(1,Data)
            .then(result=>{
                let TempData=Data;
                TempData.status="saved"
                if (result.Status) alert("Data was saved")
                localStorage.setItem("Data",JSON.stringify(TempData))
            })
    }
    function changeHouse(event){
        const House=event.currentTarget.id;
        let TempData=Data;
        if(selectedHouse==House) {
            setSelectedHouse(null)
            return;
        }
        if(!TempData[House]) TempData[House] = {Floors:{}}
        setSelectedFloor(null)
        setSelectedHouse(House)
        localStorage.setItem("Data",JSON.stringify(TempData))
        setData({...TempData});
    }
    function changeFloor(event){
        let Floor=event.currentTarget.id;
        let TempData=Data;

        if(selectedFloor === Floor) {
            setSelectedFloor(null)
            return;
        }
        if(!TempData[selectedHouse].Floors[Floor])
            TempData[selectedHouse].Floors[Floor]={WorkTypes:{}, ProgressWorkTypes:{}};

        localStorage.setItem("Data",JSON.stringify(TempData))
        setSelectedFloor(Floor)
        setData({...TempData})
    }
    function changeGoal(event){
        const Goal=event.currentTarget.id;
        setSelectedGoal(Goal)
    }
    function Goal(Goal){
        switch(Goal) {
            case "ConstructionSiteDayWorks":
                return (<ConstructionSiteDayWorks
                    Data={Data}
                    setData={setData}
                    selectedHouse={selectedHouse}
                    selectedFloor={selectedFloor}
                />)
                break;
            case "ConstructionSiteProgress":
                return (<ConstructionSiteProgress
                    Data={Data}
                    setData={setData}
                    selectedHouse={selectedHouse}
                    selectedFloor={selectedFloor}
                />)
            case "ToDo":
                return(
                    <ToDo
                        setSelectedGoal={setSelectedGoal}
                        House={selectedHouse}
                        Floor={selectedFloor}
                    />
                );
            case "Camera":
                return(
                    <PhotoProgressWorks
                        house={selectedHouse}
                        floor={selectedFloor}
                        setSelectedGoal={setSelectedGoal}
                    />
                )
        }
    }

    // console.log(Data)
    return (
        <MainDiv>
            <SectionDiv visible={true}>
                {
                    Houses.map(Element=>{
                        let checked=false
                        if (selectedHouse==Element) checked=true
                        return (
                         <LineDiv key={Element} id={Element} onClick={changeHouse}>
                             <input id={Element} type='checkbox' checked={checked}/>
                             <Text id={Element} >{Element}</Text>
                         </LineDiv>
                        )
                    })
                }
            </SectionDiv>
            <SectionDiv clickable={selectedHouse?"auto":"none"} visible={selectedHouse?"grid":"none"}>
                {
                    Floors.map(Element=>{
                        let checked=false;

                        if (selectedFloor == Element) checked = true

                        return (
                            <LineDiv id={Element} onClick={changeFloor} key={Element}>
                                <input id={Element} type='checkbox' checked={checked}/>
                                {Element}
                                {selectedHouse&&Data[selectedHouse].Floors[Element]?"+":""}
                            </LineDiv>
                        )
                    })
                }
            </SectionDiv>
            <SelectorsDiv visible={selectedFloor?"grid":"none"}>
                <SelectorDiv id="ConstructionSiteDayWorks" onClick={changeGoal} background={selectedGoal==="ConstructionSiteDayWorks"?"green":""}>Bautagebuch</SelectorDiv>
                <SelectorDiv id="ConstructionSiteProgress" onClick={changeGoal} background={selectedGoal==="ConstructionSiteProgress"?"green":""}>Ergebnis</SelectorDiv>
                <SelectorDiv id="ToDo" onClick={changeGoal} background={selectedGoal==="ToDo"?"green":""}>ToDo</SelectorDiv>
            </SelectorsDiv>
            {
                Goal(selectedGoal)
            }
            <ButtonsDiv visible={selectedHouse?"grid":"none"}>
                {
                    selectedFloor?
                        <Button id="Camera" onClick={changeGoal}>Photo</Button>
                        :""
                }
                <Button onClick={saveData}>save</Button>
            </ButtonsDiv>
        </MainDiv>
    );
};

export default GoAroundMain;